import { cn } from "@/lib/cn";

const COMPANIES = [
  "Series B SaaS",
  "Top 10 brokerage",
  "Growth-stage startup",
  "D2C brand",
  "Enterprise IT",
];

export function SocialProof({ className }: { className?: string }) {
  return (
    <div className={cn("flex flex-col items-center gap-3", className)}>
      <p className="text-sm font-medium text-muted-foreground">
        Trusted by 2,400+ teams
      </p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        {COMPANIES.map((name, i) => (
          <span
            key={name}
            className="inline-flex items-center rounded-full border border-border/60 bg-muted/50 px-3 py-1 text-xs font-medium text-muted-foreground animate-fade-in opacity-0"
            style={{ animationDelay: `${450 + i * 50}ms` }}
          >
            {name}
          </span>
        ))}
      </div>
    </div>
  );
}
